module.exports = __webpack_public_path__ + "static/media/interest.2a990404.svg";